'use client'

export default function NotificationsPreview() {
  return (
    <section className="py-12 sm:py-16 border-b border-gray-100 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4">
        <p className="text-center text-xs font-bold uppercase tracking-widest text-blue-600 mb-3">What you receive</p>
        <h2 className="text-center text-2xl sm:text-3xl font-extrabold text-gray-900 mb-2">
          Deals delivered to you
        </h2>
        <p className="text-center text-gray-500 text-sm sm:text-base mb-10 max-w-xl mx-auto">
          Personalised alerts via Telegram and email — filtered to your airports, at your preferred time.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 items-start">

          {/* ── Telegram mockup ── */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="text-lg">💬</span>
              <span className="text-sm font-semibold text-gray-700">Telegram</span>
              <span className="text-xs text-gray-400 ml-1">— real-time & daily digest</span>
            </div>
            <div className="bg-[#17212b] rounded-2xl p-4 shadow-lg">
              {/* Bot header */}
              <div className="flex items-center gap-2 mb-3 pb-3 border-b border-white/10">
                <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white text-xs font-bold">FF</div>
                <div>
                  <p className="text-white text-xs font-semibold">FairFares Deals</p>
                  <p className="text-gray-400 text-[10px]">bot</p>
                </div>
              </div>
              {/* Message bubble */}
              <div className="bg-[#2b5278] rounded-xl rounded-tl-sm p-3 max-w-[90%]">
                <p className="text-white text-xs leading-relaxed">
                  <span className="font-bold">✅ 🇳🇱 Amsterdam → 🇮🇹 Palermo</span>
                </p>
                <p className="text-blue-200 text-[11px] mt-1">
                  €145 <span className="line-through text-gray-400">€218</span>{' '}
                  <span className="bg-green-600 text-white text-[10px] font-bold px-1.5 py-0.5 rounded">-33%</span>
                </p>
                <p className="text-gray-300 text-[11px] mt-0.5">Transavia · Direct · 25 Oct – 9 Nov</p>
                <p className="text-[11px] mt-1.5">
                  <span className="text-blue-300 underline">View deal →</span>
                </p>
              </div>
              {/* Second bubble */}
              <div className="bg-[#2b5278] rounded-xl rounded-tl-sm p-3 max-w-[90%] mt-2">
                <p className="text-white text-xs leading-relaxed">
                  <span className="font-bold">🔥 🇳🇱 Amsterdam → 🇯🇵 Tokyo</span>
                </p>
                <p className="text-blue-200 text-[11px] mt-1">
                  €512 <span className="line-through text-gray-400">€890</span>{' '}
                  <span className="bg-green-600 text-white text-[10px] font-bold px-1.5 py-0.5 rounded">-42%</span>
                </p>
                <p className="text-gray-300 text-[11px] mt-0.5">KLM · Direct · +8 more dates</p>
                <p className="text-[11px] mt-1.5">
                  <span className="text-blue-300 underline">View deal →</span>
                </p>
              </div>
              <p className="text-gray-500 text-[10px] mt-3 text-right">09:04</p>
            </div>
          </div>

          {/* ── Email mockup ── */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="text-lg">📧</span>
              <span className="text-sm font-semibold text-gray-700">Email</span>
              <span className="text-xs text-gray-400 ml-1">— daily digest</span>
            </div>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
              {/* Header */}
              <div className="bg-gray-900 px-4 py-3">
                <p className="text-white text-sm font-bold">FairFares</p>
                <p className="text-gray-400 text-[11px]">unusually cheap travel</p>
              </div>
              {/* Body */}
              <div className="px-4 py-4">
                <p className="text-[10px] font-bold uppercase tracking-wider text-blue-600 mb-1">Daily Digest — Tuesday 30 June</p>
                <p className="text-sm font-extrabold text-gray-900 mb-3">✈️ Your top deals from Amsterdam</p>

                {/* Deal 1 */}
                <div className="border-b border-gray-100 pb-3 mb-3">
                  <p className="text-xs font-bold text-gray-900">✅ 🇳🇱 Amsterdam → 🇮🇹 Palermo</p>
                  <p className="text-[11px] text-gray-500 mt-0.5">Transavia · Direct · 25 Oct – 9 Nov (15n)</p>
                  <div className="flex items-center justify-between mt-1.5">
                    <div className="flex items-center gap-1.5">
                      <span className="text-base font-bold text-blue-600">€145</span>
                      <span className="text-[11px] text-gray-400 line-through">€218</span>
                      <span className="text-[10px] font-bold bg-green-600 text-white px-1.5 py-0.5 rounded">-33%</span>
                    </div>
                    <span className="text-[11px] text-blue-600 font-semibold">View deal →</span>
                  </div>
                </div>

                {/* Deal 2 */}
                <div className="border-b border-gray-100 pb-3 mb-3">
                  <p className="text-xs font-bold text-gray-900">🔥 🇳🇱 Amsterdam → 🇯🇵 Tokyo</p>
                  <p className="text-[11px] text-gray-500 mt-0.5">KLM · Direct · +8 more dates</p>
                  <div className="flex items-center justify-between mt-1.5">
                    <div className="flex items-center gap-1.5">
                      <span className="text-base font-bold text-blue-600">€512</span>
                      <span className="text-[11px] text-gray-400 line-through">€890</span>
                      <span className="text-[10px] font-bold bg-green-600 text-white px-1.5 py-0.5 rounded">-42%</span>
                    </div>
                    <span className="text-[11px] text-blue-600 font-semibold">View deal →</span>
                  </div>
                </div>

                <p className="text-[11px] text-gray-400 text-center">+ 3 more deals in your inbox</p>

                <div className="mt-3 text-center">
                  <span className="inline-block bg-gray-900 text-white text-xs font-bold px-4 py-2 rounded-lg">See all deals →</span>
                </div>
              </div>
              {/* Footer */}
              <div className="bg-gray-50 border-t border-gray-100 px-4 py-2 text-center">
                <p className="text-[10px] text-gray-400">fairfares.app</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}
